import React from 'react';
import { BILAN_HABITUDES } from '../data/bilanReprise';

const STATUS_PRINT = {
  acquis: { sym: '✓', label: 'Acquis' },
  consolider: { sym: '≈', label: 'À consolider' },
  non_acquis: { sym: '✗', label: 'Non acquis' },
};

export default function BilanPrintSheet({ type, comps, grid, habitudes, meta, stats, total, pct, verdictText, conseils, isRetour }) {
  const habChecked = isRetour ? BILAN_HABITUDES.filter((h) => habitudes[h.id]) : [];
  const aCorriger = comps.flatMap((comp) =>
    comp.criteres
      .filter((r) => grid[r.id] === 'consolider' || grid[r.id] === 'non_acquis')
      .map((r) => ({ ...r, compId: comp.id, state: grid[r.id] }))
  );

  return (
    <div className="print-only" data-testid="bilan-print-sheet" style={{ fontFamily: 'Georgia, serif', color: '#111', fontSize: '12px', lineHeight: 1.45 }}>
      {/* En-tête */}
      <div style={{ borderBottom: '2px solid #111', paddingBottom: '10px', marginBottom: '14px' }}>
        <div style={{ fontSize: '10px', letterSpacing: '2px', textTransform: 'uppercase' }}>Code Voiture · Bilan de formation</div>
        <h1 style={{ fontSize: '22px', margin: '4px 0 0' }}>{type.short}</h1>
        <div style={{ fontSize: '11px', marginTop: '2px' }}>{type.desc}</div>
      </div>

      {/* Identité & contexte */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '14px', fontSize: '12px' }}>
        <tbody>
          <tr>
            <td style={{ padding: '4px 8px', border: '1px solid #999', width: '50%' }}><strong>Élève :</strong> {meta.eleve || '________________________'}</td>
            <td style={{ padding: '4px 8px', border: '1px solid #999' }}><strong>Date :</strong> {meta.date ? (meta.date.includes('/') ? meta.date : new Date(`${meta.date}T00:00:00`).toLocaleDateString('fr-FR')) : '____ / ____ / ________'}</td>
          </tr>
          {isRetour && (
            <tr>
              <td style={{ padding: '4px 8px', border: '1px solid #999' }}><strong>Km parcourus :</strong> {meta.km || '—'} · <strong>Durée :</strong> {meta.duree || '—'} mois</td>
              <td style={{ padding: '4px 8px', border: '1px solid #999' }}><strong>RDV pédagogiques effectués :</strong> {meta.rdv || '—'}</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Verdict */}
      <div style={{ border: '2px solid #111', padding: '8px 12px', marginBottom: '14px' }}>
        <strong>VERDICT · {pct} % de critères acquis ({stats.acquis}/{total})</strong>
        <div style={{ marginTop: '3px' }}>{verdictText}</div>
        <div style={{ marginTop: '3px', fontSize: '11px' }}>
          Acquis : {stats.acquis} · À consolider : {stats.consolider} · Non acquis : {stats.non_acquis}
          {isRetour ? ` · Habitudes à corriger : ${habChecked.length}` : ''}
        </div>
      </div>

      {/* Grille détaillée */}
      {comps.map((comp) => (
        <table key={comp.id} style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '10px', fontSize: '11.5px', pageBreakInside: 'avoid' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #999', padding: '4px 8px', textAlign: 'left', background: '#eee' }} colSpan={2}>
                {comp.id} · {comp.titre}
              </th>
            </tr>
          </thead>
          <tbody>
            {comp.criteres.map((r) => {
              const st = STATUS_PRINT[grid[r.id]];
              return (
                <tr key={r.id}>
                  <td style={{ border: '1px solid #bbb', padding: '3px 8px' }}>{r.label}</td>
                  <td style={{ border: '1px solid #bbb', padding: '3px 8px', width: '110px', whiteSpace: 'nowrap', fontWeight: st ? 'bold' : 'normal' }}>
                    {st ? `${st.sym} ${st.label}` : '— Non évalué'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ))}

      {/* Éléments à corriger */}
      {aCorriger.length > 0 && (
        <div style={{ marginTop: '12px', pageBreakInside: 'avoid' }}>
          <h2 style={{ fontSize: '14px', borderBottom: '1px solid #111', paddingBottom: '3px' }}>Éléments à corriger ({aCorriger.length})</h2>
          <ul style={{ margin: '6px 0 0', paddingLeft: '18px' }}>
            {aCorriger.map((r) => (
              <li key={r.id} style={{ marginBottom: '2px' }}>
                <strong>[{r.state === 'non_acquis' ? '✗ Non acquis' : '≈ À consolider'}]</strong> {r.compId} · {r.label}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Habitudes */}
      {habChecked.length > 0 && (
        <div style={{ marginTop: '12px', pageBreakInside: 'avoid' }}>
          <h2 style={{ fontSize: '14px', borderBottom: '1px solid #111', paddingBottom: '3px' }}>Habitudes prises avec les accompagnateurs — à corriger</h2>
          <ul style={{ margin: '6px 0 0', paddingLeft: '18px' }}>
            {habChecked.map((h) => <li key={h.id} style={{ marginBottom: '2px' }}>{h.label}</li>)}
          </ul>
        </div>
      )}

      {/* Conseils */}
      {conseils && (
        <div style={{ marginTop: '12px', pageBreakInside: 'avoid' }}>
          <h2 style={{ fontSize: '14px', borderBottom: '1px solid #111', paddingBottom: '3px' }}>Conseils de l&apos;enseignant{isRetour ? ' (élève et accompagnateurs)' : ''}</h2>
          <p style={{ margin: '6px 0 0', whiteSpace: 'pre-wrap' }}>{conseils}</p>
        </div>
      )}

      {/* Signatures */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '22px', fontSize: '11px', pageBreakInside: 'avoid' }}>
        <tbody>
          <tr>
            <td style={{ border: '1px solid #999', padding: '6px 8px 34px', width: '33%' }}>Signature de l&apos;enseignant ECSR</td>
            <td style={{ border: '1px solid #999', padding: '6px 8px 34px', width: '33%' }}>Signature de l&apos;élève</td>
            <td style={{ border: '1px solid #999', padding: '6px 8px 34px' }}>Signature de l&apos;accompagnateur</td>
          </tr>
        </tbody>
      </table>

      <div style={{ marginTop: '10px', fontSize: '9.5px', color: '#555' }}>
        Document pédagogique édité avec Code Voiture — grille d&apos;évaluation basée sur les compétences du REMC. Légende : ✓ Acquis · ≈ À consolider · ✗ Non acquis.
      </div>
    </div>
  );
}
